// Generic, reason-free rejection page. Shown for missing/invalid/revoked
// tokens and any unmatched route -- deliberately says nothing specific.
export function InvalidPage() {
  return (
    <main className="grid min-h-dvh place-items-center p-6">
      <div className="card max-w-md text-center">
        <h1 className="text-2xl font-semibold">Invitation not found</h1>
        <p className="mt-3 text-muted">
          This link doesn't appear to be a valid invitation. If you believe this
          is a mistake, please check with your host for the correct link.
        </p>
      </div>
    </main>
  );
}
